// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class PartialInterval {
    constructor(leftBorder, rightBorder) {
        this.IsSelected = true;
        this.LeftBorder = leftBorder;
        this.RightBorder = rightBorder;
    }
    get text() {
        let value;
        if (this.RightBorder === Number.POSITIVE_INFINITY) {
            value = this.LeftBorder * 1.2;
        }
        else if (this.LeftBorder === Number.NEGATIVE_INFINITY) {
            value = this.RightBorder * 1.2;
        }
        else {
            value = (this.LeftBorder + this.RightBorder) / 2;
        }
        return value.toString() + '%';
    }
    contains(value) {
        if (Math.abs(this.RightBorder) === Math.abs(this.LeftBorder)) {
            return value > this.LeftBorder && value < this.RightBorder;
        }
        if (value > 0) {
            return value >= this.LeftBorder && value < this.RightBorder;
        }
        return value > this.LeftBorder && value <= this.RightBorder;
    }
    toString() {
        return `${this.LeftBorder} - ${this.RightBorder}:${this.LeftColor}`;
    }
    equals(other) {
        if (other === null) {
            return false;
        }
        if (this === other) {
            return true;
        }
        return this.LeftBorder === other.LeftBorder && this.RightBorder === other.RightBorder;
    }
}
